import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { mmtc_sell_responseApi } from "../../app/slices/mmtc/mmtc_sell_responseSlice";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";

import { Box, Tooltip } from "@mui/material";
import { IconButton } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { toast } from "react-toastify";
import Filter from "../../components/Filter";
import useFilterHandler from "../../components/filterhandler";
import Loader from "../digitalGold/Loader";

export default function MmtcSellResponse() {
  const dispatch = useDispatch();
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });

  const [filterData, setFilterData] = useState({
      startDate: "",
      endDate: "",
      name: "",
      transactionId: "",
     invoiceId:"",
      customerRefNo: "",
      metalType:"",
      quoteId:"",
      merchantTransactionId:"",
    });
  
      const url = `/api/admin/mmtc-sell-res/list`
    
      const { handleFilterSubmit, handleClearFilters, loader, results, apiCall,message,error,toastTrigger } = useFilterHandler(url, filterData, setFilterData)
  
  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };
  // useEffect(() => {
  //   dispatch(mmtc_sell_responseApi(queryParams));
  // }, [dispatch, queryParams]);

   useEffect(() => {
      apiCall(false)
    }, []);
  
     useEffect(() => {
    if (!message) return;
  
    console.log("Message updated:", message);
  
    if (error) {
      toast.error(message);
    }
    //  else {
    //   // toast.success(message);
    // }
  }, [toastTrigger]);

  const sliceResponse = useSelector(
    (state) => state.mmtc_sell_response.mmtc_sell_response.data
  );
  const stateLoading = useSelector(
    (state) => state.mmtc_sell_response.loading
  );

  const columnHelper = createMRTColumnHelper();

  const columns = [
    // columnHelper.accessor("_id", {
    //   header: "ID",
    //   size: 30,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?._id);
    //       toast.success("Copied to clipboard!");
    //     };
    //     return (
    //       <Tooltip title={cell.row.original?._id}>
    //         <IconButton onClick={handleCopy}>
    //           <ContentCopy />
    //         </IconButton>
    //       </Tooltip>
    //     );
    //   },
    // }),
    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("customerName", {
      header: "Name",
      size: 100,
    }),

    columnHelper.accessor("metalType", {
      header: "Metal Type",
      size: 30,
    }),

     columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 30,
    }),
    // columnHelper.accessor("type", {
    //   header: "Type",
    //   size: 30,
    // }),
//      columnHelper.accessor("pricePerG", {
//   header: "Price per Gram",
//   size: 30,
//   Cell: ({ row }) => {
//     const pricePerG = row.original.pricePerG;
//     const metalRate = row.original.metalRate;

//     return pricePerG ? pricePerG : metalRate;
//   },
// }),

     columnHelper.accessor("metalRate", {
  header: "Metal Rate",
  size: 30,
  Cell: ({ row }) => {
    const metalRate = row.original.metalRate;
    const pricePerG = row.original.pricePerG;

    return metalRate ? metalRate : pricePerG;
  },
}),
   
    columnHelper.accessor("totalAmount", {
      header: "Total Amount",
      size: 30,
    }),

    //  columnHelper.accessor("netAmount", {
    //   header: "Net Amount",
    //   size: 30,
    // }),

    //  columnHelper.accessor("pricePerG", {
    //   header: "Price per Gram",
    //   size: 30,
    // }),

   

    // columnHelper.accessor("preTaxAmount", {
    //   header: "Pre Tax Amount",
    //   // header: "Pre-Tax Amount",
    //   size: 30,
    // }),
    // columnHelper.accessor("taxType", {
    //   header: "Tax Type",
    //   size: 50,
    // }),
    // columnHelper.accessor("tax1Amt", {
    //   header: "Tax 1 Amount",
    //   size: 30,
    // }),
    // columnHelper.accessor("tax2Amt", {
    //   header: "Tax 2 Amount",
    //   size: 30,
    // }),
    // columnHelper.accessor("tax3Amt", {
    //   header: "Tax 3 Amount",
    //   size: 30,
    // }),
    // columnHelper.accessor("taxAmount", {
    //   header: "Total Tax Amount",
    //   size: 30,
    // }),
    
   
     
    // columnHelper.accessor("pricePerG", {
    //   header: "Price per Gram",
    //   size: 30,
    // }),

    columnHelper.accessor("orderId", {
      header: "Order ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.orderId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.orderId}>
            <>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.orderId}
              </span>
            </>

          </Tooltip>
        );
      },
    }),

     columnHelper.accessor("quoteId", {
      header: "Quote ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.quoteId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.quoteId}>
            <>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.quoteId}
              </span>
            </>

          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("transactionId", {
      header: "Transaction ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.transactionId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.transactionId}>
            <>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.transactionId}
            </>
          </Tooltip>
        );
      },
    }),

     columnHelper.accessor("transactionRefNo", {
      header: "Transaction RefNo",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.transactionRefNo);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.transactionRefNo}>
            <>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.transactionRefNo}
            </>
          </Tooltip>
        );
      },
    }),

     columnHelper.accessor("billingAddressId", {
      header: "Billing Address ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.orderId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.orderId}>
            <>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.orderId}
              </span>
            </>

          </Tooltip>
        );
      },
    }),

     columnHelper.accessor("invoiceId", {
      header: "Invoice ID",
      size: 50,
      Cell: (cell) => cell.row.original?.invoiceId ,
    }),

    // columnHelper.accessor("orderId", {
    //   header: "Order ID",
    //   size: 50,
    // }),
    // columnHelper.accessor("transactionId", {
    //   header: "Transaction ID",
    //   size: 50,
    // }),
    columnHelper.accessor("executionDateTime", {
      header: "Execution Date",
      size: 50,
      Cell: (cell) =>
        cell.row.original.executionDateTime
          ? cell.row.original.executionDateTime.split("T")[0]
          : "N/A",
    }),
    columnHelper.accessor("settlementId", {
      header: "Settlement ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.settlementId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.settlementId}>
            <>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.settlementId}
              </span>
            </>

          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("provider", {
      header: "Settlement Provider",
      size: 50,
    }),
    // columnHelper.accessor("settlementType", {
    //   header: "Settlement Type",
    //   size: 50,
    // }),
    columnHelper.accessor("payout_payment_id", {
      header: "Payout Payument ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.settlementId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.settlementId}>
            <>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.settlementId}
              </span>
            </>

          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("payout_status", {
      header: "Payout Status",
      size: 50,
    }),
    columnHelper.accessor("payout_account_id", {
      header: "Payout Account ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.payout_account_id);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.payout_account_id}>
            <>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.payout_account_id}
              </span>
            </>

          </Tooltip>
        );
      },
    }),
   

    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 50,
    }),
    // columnHelper.accessor("payoutAccountId", {
    //   header: "Payout Account ID",
    //   size: 50,
    // }),
    // columnHelper.accessor("remainingBalance_1_balQuantity", {
    //   header: "Remaining Balance 1 (Qty)",
    //   size: 50,
    // }),
    // columnHelper.accessor("remainingBalance_1_currencyPair", {
    //   header: "Remaining Balance 1 (Currency)",
    //   size: 50,
    // }),
    // columnHelper.accessor("remainingBalance_1_blockedQuantity", {
    //   header: "Remaining Balance 1 (Blocked)",
    //   size: 50,
    // }),
    // columnHelper.accessor("remainingBalance_2_balQuantity", {
    //   header: "Remaining Balance 2 (Qty)",
    //   size: 50,
    // }),
    // columnHelper.accessor("remainingBalance_2_currencyPair", {
    //   header: "Remaining Balance 2 (Currency)",
    //   size: 50,
    // }),
    // columnHelper.accessor("remainingBalance_2_blockedQuantity", {
    //   header: "Remaining Balance 2 (Blocked)",
    //   size: 50,
    // }),
    // columnHelper.accessor("billingAddressId", {
    //   header: "Billing Address ID",
    //   size: 50,
    //   Cell: (cell) => cell.row.original?.billingAddressId || "N/A",
    // }),
   
  ];



  return (
    <>
     {/*  */}
      <Filter filterData={filterData} onFilterSubmit={handleFilterSubmit} Onclear={handleClearFilters} page={'mmtc_sell_res'} setFilterData={setFilterData} />
    
      {/* <DateSearchComponent onSearch={handleSearch} /> */}
      <Box mt={2}>
       {loader?<Loader/> : <CustomTable columns={columns} data={results} loading={loader} permissionKey="MMTCSellResponse" />}
      </Box>
    </>
  );
}
